<div class="referral-wrapper current-referrals">
	<div class="my-referral-requests">
		<div class="row">
			<div class="col-md-12">
				<!-- Not present in current wireframe -->
				<!-- <div class="r-p-title-container">
          <div class="title">
            <h2 [translate]="'referral.my-referral-requests.title'">Referral Requests</h2>
          </div>
          <div class="addons" *ngIf="!noData">
            <a (click)="print()">
              <i class="fa fa-print"></i>
              <span [translate]="'referral.print.title'">Print</span>
            </a>
          </div>
        </div> -->
				<p *ngIf="data && !noData" [translate]="'referral.my-referral-requests.description'">
					Your referral has been sent to our Referral Team. You will be notified when the referral is ready.
				</p>
			</div>
		</div>
		<div class="row" *ngIf="data">
			<div class="col-md-12">
				<ng-container *ngFor="let category of data?.category">
					<ng-container *ngFor="let referral of category.referral; let i = index">
						<div class="c-r-module">
							<mat-accordion>
								<mat-expansion-panel>
									<mat-expansion-panel-header>
										<div class="title">
											<h3>{{ referral.specialtyName }}</h3>
											<p>
												<span [translate]="'referral.my-referral-requests.last-updated'">Last updated: </span>
												{{ referral.lastUpdatedDate | date: 'MMM. dd, yyyy' }}
											</p>
										</div>
									</mat-expansion-panel-header>
									<mat-panel-description>
										<div class="c-r-content">
											<div class="c-r-row">
												<div class="c-r-r-label">
													<p [translate]="'referral.my-referral-requests.reason'">Reason for Request:</p>
												</div>
												<div class="c-r-r-val">
													<p>{{ referral.reason }}</p>
												</div>
											</div>
											<div class="c-r-row" *ngIf="referral?.apptPrefs && referral?.apptPrefs?.location">
												<div class="c-r-r-label">
													<p [translate]="'referral.my-referral-requests.provider-preferences'">
														Physician Preferences
													</p>
												</div>
												<div class="c-r-r-val">
													<ng-container *ngFor="let location of referral.apptPrefs.location">
														<p>
															<b [translate]="'referral.my-referral-requests.location'">Location:</b>
															{{ location.city }}, {{ location.state }} {{ location.zip }}
														</p>
													</ng-container>
													<p>
														<b [translate]="'referral.my-referral-requests.gender'">Gender:</b>
														{{ referral.apptPrefs.genderPref }}
													</p>
												</div>
											</div>
											<div class="c-r-row" *ngIf="referral?.apptPrefs && referral?.apptPrefs?.dateTime">
												<div class="c-r-r-label">
													<p [translate]="'referral.my-referral-requests.preferred-appt-date.date'">
														Preferred Appt. Date
													</p>
												</div>
												<div class="c-r-r-val">
													<ng-container *ngFor="let date of referral.apptPrefs.dateTime">
														<p>{{ getFormattedDate(date.date) }} {{ date.fromTime }} - {{ date.toTime }}</p>
													</ng-container>
													<p>
														<b [translate]="'referral.my-referral-requests.preferred-appt-date.note'">Note:</b>
														{{ referral.apptPrefs.note }}
													</p>
												</div>
											</div>
											<div class="c-r-row">
												<div class="c-r-r-label">
													<p [translate]="'referral.sections.medical-record'">Medical Record</p>
												</div>
												<div class="c-r-r-val">
													<p
														*ngIf="referral.apptPrefs.transferEheRecords"
														[translate]="'referral.medical-record.transfer'">
														Please transfer my EHE exam records to physicians
													</p>
													<p
														*ngIf="!referral.apptPrefs.transferEheRecords"
														[translate]="'referral.medical-record.dont-transfer'">
														Please don't transfer my EHE exam records to physician
													</p>
												</div>
											</div>
											<div class="c-r-row">
												<ng-container *ngFor="let insurance of referral.apptPrefs.insurance">
													<div class="c-r-row no-border">
														<div class="c-r-r-label">
															<p>
																<span [translate]="'referral.my-referral-requests.insurance-information.title'"
																	>Insurance Information</span
																>
															</p>
														</div>
														<div class="c-r-r-val">
															<p>
																<b>
																	<span [translate]="'referral.my-referral-requests.insurance-information.plan-name'"
																		>Plan Name:</span
																	>
																</b>
																{{ getInsurancePlanName(insurance?.planId) }}
															</p>
															<p>
																<b>
																	<span [translate]="'referral.my-referral-requests.insurance-information.plan-type'"
																		>Plan Type:</span
																	>
																</b>
																{{ getInsurancePlanType(insurance?.planTypeId) }}
															</p>
															<p>
																<b>
																	<span [translate]="'referral.my-referral-requests.insurance-information.member-id'"
																		>Member ID:</span
																	>
																</b>
																{{ insurance.memberId !== '' ? insurance.memberId : '-' }}
															</p>
															<p>
																<b>
																	<span [translate]="'referral.my-referral-requests.insurance-information.group-number'"
																		>Group Number:</span
																	>
																</b>
																{{ insurance.groupNnumber !== '' ? insurance.groupNnumber : '-' }}
															</p>
															<p>
																<b>
																	<span
																		[translate]="
																			'referral.my-referral-requests.insurance-information.outside-insurance'
																		"
																		>Find physician outside of my insurance:</span
																	>
																</b>
																{{ referral.apptPrefs.outOfNetwork ? 'Yes' : 'No' }}
															</p>
														</div>
													</div>
												</ng-container>
											</div>
										</div>
									</mat-panel-description>
								</mat-expansion-panel>
							</mat-accordion>
						</div>
					</ng-container>
				</ng-container>
				<ng-container *ngIf="noData">
					<div class="align-center">{{ noDataMsg }}</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>
